*:hover {
  cursor: pointer;
}

.tile {
  padding: 1em;
  font-size: 0.75em;
  text-align: left;
  background-color: var(--theme-primary-background);
  display: flex;
  flex-direction: column;
  border: none;
  border-radius: var(--Common--border-radius);
  text-decoration: none;
  position: relative;
  width: 100%;
}

img {
  display: block;
  width: 100%;
  min-height: var(--aha-image-tile--height, auto);
  object-fit: contain;
  object-position: center top;
}

p {
  margin: 0;
  padding-top: 1em;
  display: flex;
  color: var(--theme-primary-text);
  /* Force really long words to break */
  overflow-wrap: anywhere;
}

:host {
  font-size: 1rem;
}

button {
  box-shadow: 0 0 0 transparent;
  border: none;
  background-color: unset;
  padding: 0;
  text-align: left;
}

a {
  text-decoration: none;
}

.tile:active {
  background-color: var(--theme-list-item-active-background);
}

:host([selected]) .tile {
  background-color: var(--theme-list-item-active-background);
}

.tile:hover,
.tile:focus-within {
  background-color: var(--theme-list-item-hover-background);
}

.tile:hover .image-container,
.tile:focus-within .image-container {
  background-color: var(--theme-list-item-hover-background);
}

.tile:hover button,
.tile:focus-within button {
  outline: none;
}

/* The overlay container is needed because we don't want to have
 * overflow hidden affecting the overlay */
.overlay-container {
  position: relative;
}

/* Lots of containers. The img is stretched to the full width while
 * maintaining aspect ratio. Then we have the inner wrapper to cut off
 * the overflow. Finally the image container is to allow a border around
 * the cut off content and so we have the proper letterbox background. */
.image-container {
  background-color: var(--theme-primary-background);
  border-radius: var(--Common--border-radius);
  border: var(--aha-image-tile--border, none);
  overflow: hidden;
  max-height: var(--aha-image-tile--height, auto);
  box-sizing: border-box;
}

.inner-image-container {
  max-height: var(--aha-image-tile--height, auto);
  overflow: hidden;
}

.overlay {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
}
